import { LineBreakWrapper } from './styles/line-break.styles'

const LineBreak = ({gap,color}:{gap:string,color?:string}) => {
  return (
   <LineBreakWrapper gap={gap} color={color} />
  )
}

export default LineBreak